// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_7m-0";
export var optionCard = "_7m-1";